
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/untuk-anda",
      function () {
        return require("private-next-pages/untuk-anda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/untuk-anda"])
      });
    }
  